import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SessionContext from '../../../../library/Core/SessionContext';
import PopUpImg from '../../../../styles/images/pop-img.png';

const CertificationVisual = `${process.env.REACT_APP_IMAGE_BASEPATH}/achievements_visual.svg`;

const CertificationLayout = (props: any) => {
    const { sessionState } = useContext(SessionContext);
    const userStatusCode = sessionState?.userStatusCode;
    const userTypeCode = sessionState?.userTypeCode;
    const profileStatusCode = sessionState?.profileStatusCode;
    const isInternalHeaderActive =
        userTypeCode != 'SUPER_ADMIN' &&
        userTypeCode != 'INSTITUTE_ADMIN' &&
        userStatusCode != 'ACTIVE' &&
        profileStatusCode != 'basic-info-complete' &&
        profileStatusCode != 'COMPLETE';

    const [profilePercentage, setprofilePercentage] = useState<any>('');
    const SchoolLogo = sessionStorage.getItem('school-image') as any;

    useEffect(() => {
        const pct = sessionStorage.getItem('profile-percentage') ? sessionStorage.getItem('profile-percentage') : 0;
        setprofilePercentage(pct);
    }, [sessionStorage.getItem('profile-percentage')]);

    const navigate = useNavigate();

    return (
        <>
            {isInternalHeaderActive && (
                <header className="ful-header">
                    <div className="header_container">
                        <a href="">
                            <img src={SchoolLogo} alt="" />
                        </a>
                        <label className="user_name">
                            Hey <span>{`${sessionState?.firstName} ${sessionState?.lastName}`}</span>
                        </label>
                    </div>
                </header>
            )}
            <div className="main-wrap">
                <section className="scholarship_banner d-none d-md-block aos-init aos-animate" data-aos="fade-down">
                    <div className="scholarship_container">
                        <div className="row g-4">
                            <div className="col-md">
                                <h2>
                                    Your <span>Certifications</span> Matter{' '}
                                </h2>
                                <ul className="scholarship_detail_list">
                                    <li>Adding your Certifications increases your Profile Credibility.</li>
                                </ul>
                            </div>
                            <div className="col-md-auto text-center d-flex align-items-end justify-content-center pt-0 pt-md-5">
                                <img src={CertificationVisual} alt="" />
                            </div>
                        </div>
                    </div>
                </section>
                <div className="step_header_wrap bg-pink-gradient">
                    <div className="step_header_wrap_title">
                        <h2>CERTIFICATION DETAILS AND ITS IMPORTANCE -</h2>
                        <div className="listed_points collapse" id="certification_detail_list">
                            <ul className="scholarship_detail_list pink-line">
                                <li>Showcase Verified Skills</li>
                                <li>Boost Mentoring Opportunities</li>
                                <li>Highlight Continuous Learning</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <section className="scholarship_detail_carousel">
                    <div className="scholarship_detail_carousel_container">
                        <div className="row g-4">
                            <div className="col-lg aos-init aos-animate" data-aos="fade-right">
                                <form className="row g-3 needs-validation was-validated">
                                    <div className="steps showTab" date-bgclr="basic-information" id="step1">
                                        <div className="steps_questions mx-auto">{props.children}</div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className="modal fade show" id="skip_pop" aria-labelledby="skip_popLabel" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="brife">
                                <h4>EARNED IT? SHOW IT!</h4>
                                <p>Add your certifications to make your profile stand out.</p>
                            </div>
                            <div className="img_pop">
                                <img src={PopUpImg} alt="" />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-goback"
                                data-bs-target="#exampleModalToggle"
                                data-bs-toggle="modal"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    document.getElementsByClassName('modal').item(0)?.setAttribute('style', 'display:none');
                                }}>
                                GO BACK
                            </button>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    sessionStorage.setItem('user-status-code', 'ACTIVE');
                                    document.getElementById('updateUserStatusCode')?.click();
                                    navigate('/alumni/dashboard');
                                }}
                                className="btn btn-later">
                                I'LL DO THIS LATER
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CertificationLayout;
